import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-rep/resale/resales";
const apiEndpointIndependentResale = API_BASE_URL_ENV() + "/sales-rep/resale/dropdown/independent-resales?status=Live";
const apiEndpointResaleInCompound = API_BASE_URL_ENV() + "/sales-rep/resale/dropdown/resales-in-compound";
 const statusApi=API_BASE_URL_ENV() + "/sales-rep/resale/toggle";
 const updateApi=API_BASE_URL_ENV() + "/sales-rep/resale/request-to-update-resale";
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
 
    toggleStatus=(id)=>{
        return http.get(`${API_BASE_URL_ENV()}/sales-rep/settings/toggle-activation/resale/${id}`)   
    }

    updateStatus=(id,data)=>{
        return http.post(`${statusApi}/${id}`, data)
    }

    getIndependentResaleDropDown = (id) => {
        return http.get(apiEndpointIndependentResale)
    }

    getResaleInCompoundDropDown = (id) => {
        return http.get(`${apiEndpointResaleInCompound}?compound_id=${id}&status=Live`)
    }

    askForUpdate = (id) => {
        return http.post(updateApi, id)
    }
}
